// Recharts красит SVG-атрибутами, а не классами, поэтому токены темы ему надо
// отдавать значениями. Светлые значения совпадают с `:root` в index.css,
// тёмные — с `html.dark`.

const LIGHT = {
  gridLine: '#e8ecf2',      // --c-line
  textSecondary: '#6e7480', // --c-ink-muted
  barEmpty: '#f2f5f9',      // --c-fill: бар без данных
  cursorFill: 'rgba(75, 116, 216, 0.06)',
  barGreen: '#10b981',
  barAmber: '#f59e0b',
  barRed: '#ef4444',
  brand: '#4b74d8',
};

const DARK = {
  gridLine: '#2a3038',
  textSecondary: '#9aa3b2',
  barEmpty: '#21262e',
  cursorFill: 'rgba(107, 142, 230, 0.12)',
  barGreen: '#35c07a',
  barAmber: '#f5a742',
  barRed: '#ff6b4a',
  brand: '#6b8ee6',
};

export const CHART_THEMES = { light: LIGHT, dark: DARK };

export const chartTheme = (theme) => CHART_THEMES[theme] || LIGHT;
